import React from 'react';

import { Route } from 'react-router-dom';
import styled, { ThemeProvider, css } from 'styled-components';

import { GlobalStyle } from '../styles/globalStyle';
import { theme } from '../styles/themes';
import { If, Then, Else } from 'react-if';

import Header from '../components/MainHeader';
import Footer from '../components/Footer';
import Banner from '../components/Banner';

const StyledLayout = styled.div`
  width:100%;
  min-height:100vh;
  .body-wrapper {
    width:100%;
    margin: 0px auto;
    padding: 50px 15px;
  }



`

const Content = styled.div`
    width:100%;
    max-width:800px;
    margin:20px auto 0px;
`;

const Body = (props) => {
    return (
        <>
            {props.children}
        </>
    )
}

const Layout = ({ component: Component, className='',menu=true, ...rest }) => {
    document.title = rest.title;
    return (
        <Route {...rest} render={props => (
            <Body>
                
                <GlobalStyle />
                <ThemeProvider theme={theme}>
                    <StyledLayout className={`layout ${className}`}>
                        <If condition={menu}>
                            <Then>
                                <Header title="" />
                                <Banner title="Abonos"/>
                            </Then>
                        </If>                        
                        <div className="body-wrapper">
                            <Content>
                                <Component {...props} />
                            </Content>
                        </div>
                        <If condition={menu}>
                            <Then>
                                <Footer />
                            </Then>
                        </If>                        
                    </StyledLayout>
                </ThemeProvider>
            </Body>
        )} />
    )
}

export default Layout
